'use strict';

import VueRouter from 'vue-router';
import userAgent from './libs/user-agenet';
import Content from './components/contents/Content'; // MP4だけはノンタッチ再生のために初期でロードしておきたいので
import store from './store';

let ScanInstruction = resolve=>require(['./components/disc-scan/ScanInstruction'], resolve);
let ScanResult      = resolve=>require(['./components/disc-scan/ScanResult'], resolve);

let DiscData = resolve=>require(['./components/discs/DiscData'], resolve);

let PcPage          = resolve=>require(['./components/static-page/PcPage'], resolve);
let About           = resolve=>require(['./components/static-page/About'], resolve);
let TermsOfService  = resolve=>require(['./components/static-page/TermsOfService'], resolve);
let Contact         = resolve=>require(['./components/static-page/Contact'], resolve);
let ContactSupport  = resolve=>require(['./components/static-page/ContactSupport'], resolve);
let ContactBusiness = resolve=>require(['./components/static-page/ContactBusiness'], resolve);

let ContactOthers     = resolve=>require(['./components/static-page/ContactOthers'], resolve);
let RequestFreeSample = resolve=>require(['./components/static-page/RequestFreeSample'], resolve);
let ContactFinish     = resolve=>require(['./components/static-page/ContactFinish'], resolve);
let PrivacyPolicy     = resolve=>require(['./components/static-page/PrivacyPolicy'], resolve);
let PublicNotice      = resolve=>require(['./components/static-page/PublicNotice'], resolve);
let HowTo             = resolve=>require(['./components/static-page/HowTo'], resolve);
let Notice            = resolve=>require(['./components/static-page/Notice'], resolve);
let Support           = resolve=>require(['./components/static-page/Support'], resolve);
let NotFound          = resolve=>require(['./components/static-page/NotFound'], resolve);
let ShowCase          = resolve=>require(['./components/static-page/ShowCase'], resolve);
let Solutions         = resolve=>require(['./components/static-page/Solution'], resolve);
let DocumentInfo      = resolve=>require(['./components/static-page/solutions/DocumentInfo'], resolve);
let DocumentDownload  = resolve=>require(['./components/static-page/solutions/DocumentDownload'], resolve);
let Company           = resolve=>require(['./components/static-page/Company'], resolve);
let Release           = resolve=>require(['./components/static-page/Release'], resolve);

let PrivacyPolicyLine  = resolve=>require(['./components/static-page/PrivacyPolicyLine'], resolve);
let TermsOfServiceLine = resolve=>require(['./components/static-page/TermsOfServiceLine'], resolve);

let LineLanding = resolve=>require(['./components/discs/LineLanding'], resolve);

let Takei = resolve=>require(['./components/Takei'], resolve);

/**
 * スマホじゃないと表示しないか
 * @param to
 * @param from
 * @param next
 */
function requireSmartPhone(to, from, next){
  if(userAgent.isSmartPhone()){
    // スマホだったらOK
    next();
  }else if(process.env.NODE_ENV === 'development'){
    // devなら表示してもおｋ
    next();
  }else{
    // PCならPC用画面にリダイレクト
    next({
      name: 'pc'
    });
  }
  
  //next();
}

let routes = [
  {
    path:        '/',
    name:        'home',
    component:   ScanInstruction,
    beforeEnter: requireSmartPhone,
    meta:        {
      isExtendContentDiv: true
    }
  },
  {
    path:        '/disc/scan/instruction',
    name:        'scanInstruction',
    component:   ScanInstruction,
    beforeEnter: requireSmartPhone,
    meta:        {
      isExtendContentDiv: true
    }
  },
  {
    path:        '/disc/scan/result',
    name:        'scanResult',
    component:   ScanResult,
    beforeEnter: requireSmartPhone,
    meta:        {
      isExtendContentDiv: true
    }
  },
  {
    path:        '/disc_data',
    name:        'discData',
    component:   DiscData,
    beforeEnter: requireSmartPhone,
    meta:        {
      isExtendContentDiv: true
    }
  },
  {
    path:        '/disc_data/content/:index',
    name:        'content',
    component:   Content,
    beforeEnter: requireSmartPhone,
    meta:        {
      isExtendContentDiv: true
    }
  },
  {
    path:        '/pc',
    name:        'pc',
    component:   PcPage,
    beforeEnter: function(to, from, next){
      if(userAgent.isSmartPhone()){
        // スマホだったらOK
        next({
          name: 'home'
        });
      }else{
        // PCはこのページが見れる
        next();
      }
    },
    meta:        {
      isExtendContentDiv: true
    }
  },
  {
    path:      '/about',
    name:      'about',
    component: About,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/tos',
    name:      'termsOfService',
    component: TermsOfService,
    beforeEnter: function(to, from, next){
      if(store.getters.mode === 'liff'){
        next({
          name: 'termsOfServiceLine'
        });
      } else {
        next();
      }
    },
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/privacy_policy',
    name:      'privacyPolicy',
    component: PrivacyPolicy,
    beforeEnter: function(to, from, next){
      if(store.getters.mode === 'liff'){
        next({
          name: 'privacyPolicyLine'
        });
      } else {
        next();
      }
    },
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/public_notice',
    name:      'publicNotice',
    component: PublicNotice,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/howto',
    name:      'howto',
    component: HowTo,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/support',
    name:      'support',
    component: Support,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/contact',
    name:      'contact',
    component: Contact,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/contact/support',
    name:      'contactSupport',
    component: ContactSupport,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/contact/business',
    name:      'contactBusiness',
    component: ContactBusiness,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/contact/others',
    name:      'contactOthers',
    component: ContactOthers,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/free_sample',
    name:      'requestFreeSample',
    component: RequestFreeSample,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/contact/finish',
    name:      'contactFinish',
    component: ContactFinish,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/notfound',
    name:      'notFound',
    component: NotFound,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/showcase',
    name:      'showCase',
    component: ShowCase,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/solutions',
    name:      'solutions',
    component: Solutions,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/document/info',
    name:      'documentInfo',
    component: DocumentInfo,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      'd',
    name:      'documentDownload',
    component: DocumentDownload,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/notice',
    name:      'notice',
    component: Notice,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/company',
    name:      'company',
    component: Company,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/release',
    name:      'release',
    component: Release,
    meta:      {
      isExtendContentDiv: false
    }
  },
  // LINE
  {
    path:      '/about/line',
    name:      'aboutLine',
    component: About,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/support/line',
    name:      'supportLine',
    component: Support,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/tos/line',
    name:      'termsOfServiceLine',
    component: TermsOfServiceLine,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/privacy_policy/line',
    name:      'privacyPolicyLine',
    component: PrivacyPolicyLine,
    meta:      {
      isExtendContentDiv: false
    }
  },
  {
    path:      '/line/landing',
    name:      'lineLanding',
    component: LineLanding,
    beforeEnter: requireSmartPhone,
    meta:      {
      isExtendContentDiv: false
    }
  },
  // テスト
  {
    path:      '/takeihideyuki',
    name:      'takei',
    component: Takei
  },
  {
    path:      '*',
    component: NotFound,
    meta:      {
      isExtendContentDiv: false
    }
  }
];

let router = new VueRouter({
  mode:   'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition){
    // スクロールポジション保存
    let y = 0;
    
    if(savedPosition && savedPosition.y && savedPosition.y > 0){
      y = savedPosition.y;
    }
    
    return {
      x: 0,
      y: y
    };
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js